import { render, staticRenderFns } from "./PillCheckbox.vue?vue&type=template&id=85aa4b5e&scoped=true&"
import script from "./PillCheckbox.vue?vue&type=script&lang=ts&"
export * from "./PillCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./PillCheckbox.vue?vue&type=style&index=0&id=85aa4b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85aa4b5e",
  null
  
)

export default component.exports